require('./hireCardOpenYoungStep1.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getEmail } = require('utilities/personalDataHelper');
const { PRODUCT_NAME: { OPEN_YOUNG } } = require('utilities/tagging');

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const { OKCheckbox } = require('commonsComponents/OKCheckbox')

// @constants
const {
    FIRST_STEP,
    OPENYOUNG_CARD_TYPE,
    OPENYOUNG_CARD_SUBTYPE,
    OPENYOUNG_CARD_STANDARD,
} = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const {
    OPEN_YOUNG_CARD_PRODUCT_ALIAS,
    PRODUCT_HIRING_COMPONENT_ID
} = require('constants/hiringProductInformation');
const { GC } = require('constants/flagBasedFeatures');


class HireCardOpenYoungStep1 extends React.Component {
    componentDidMount() {
        const {
            getOpenYoungProfiles,
            immOpenYoungProfiles,
            requestPDFMerge,
            setTermsAndCondsText,
        } = this.props;

        if (!immOpenYoungProfiles.get('fetchSuccess')) {
            getOpenYoungProfiles();
        }

        if (!__CONTACT_CENTER__) {
            const pdfurls = getCardsPreContractPdfData()['open_young_card'].preContractPdfLink;
            const product = {
                type: '506',
                subtype: '010',
                standard: '0000001'
            };
            requestPDFMerge(pdfurls, [product]);
        } else {
            setTermsAndCondsText('hireCardOpenYoung-step3CheckboxText');
        }
    }

    buildLegalConfirmationSection() {
        const { immHireInformation, immHiringProductInformation, gestorCrossEnabled } = this.props
        const information = gestorCrossEnabled ? immHiringProductInformation.get('cmsResponse') : immHireInformation.get('information');

        if (!__CONTACT_CENTER__ || !information) {
            return null;
        }

        const {
            contractName,
            handleAgreementCheckboxChange,
            immHireCardOpenYoung,
            immPreContractualMail,
            immProfileFields,
            requestProfile,
            sendPreContractualMail,
        } = this.props;
        const clientEmail = getEmail(immProfileFields);
        const profileError = immProfileFields.get('error');
        const immStep = immHireCardOpenYoung.getIn(['steps', FIRST_STEP]);
        const sendMailParams = {
            type: OPENYOUNG_CARD_TYPE,
            subType: OPENYOUNG_CARD_SUBTYPE,
            standar: OPENYOUNG_CARD_STANDARD
        };
        const agreementLabel = <FormattedText value="hireCardOpenYoung-step3CheckboxText" />;
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardOpenYoung-step3CheckboxErrorMsg');
        const hasBeenEmailSent = immPreContractualMail.get('mailSent');

        return (
            <section className="hire-card-open-young__contact-center-email">
                <PreContractualMailInfo
                    contractName={contractName}
                    email={clientEmail}
                    preContractualMail={immPreContractualMail}
                    profileError={profileError}
                    requestProfile={requestProfile}
                    sendEmail={sendPreContractualMail}
                    sendMailParams={sendMailParams}
                />

                <div className="hire-card-open-young-step-one__checkbox-container">
                    <OKCheckbox
                        idName="hireCardOpenDebitAgreementCheckbox"
                        errorState={agreementErrorVisible}
                        errorMessage={agreementErrorMsg}
                        label={agreementLabel}
                        onChange={handleAgreementCheckboxChange}
                        value={agreementChecked}
                        disabled={!hasBeenEmailSent}
                    />
                </div>
            </section>
        );
    }

    render() {
        const { hireCmsKey, immHireInformation, gestorCrossEnabled, flagBasedFeatures } = this.props;
        const legalConfirmation = this.buildLegalConfirmationSection();
        let productInformationComponent;
        if (gestorCrossEnabled && flagBasedFeatures.get(GC)) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={OPEN_YOUNG_CARD_PRODUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    {
                        legalConfirmation
                    }
                </React.Fragment>
            )
        } else {
            productInformationComponent = (
                <article className="hire-card-open-young-step-one">
                    <FormattedText
                        className="hire-card-open-young__step-title"
                        value="hireCardOpenYoung-hireCardOpenYoung_step1Title"
                    />
                    <HireInformation
                        hireCmsKey={hireCmsKey}
                        immHireInformation={immHireInformation}
                        tealiumProcess={OPEN_YOUNG}
                    />
                    {
                        legalConfirmation
                    }
                </article>
            )
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

HireCardOpenYoungStep1.propTypes = {
    contractName: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    getOpenYoungProfiles: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCmsKey: PropTypes.string.isRequired,
    immHireCardOpenYoung: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immOpenYoungProfiles: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.object.isRequired,
    sendPreContractualMail: PropTypes.object.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
};

module.exports = HireCardOpenYoungStep1;
